import styled from '@emotion/styled'
import { Switch } from 'antd'

/** The Active/Inactive toggle shown in a form's header */
export const ActiveSwitch = styled(Switch)`
  box-shadow: none;

  &:focus-visible,
  &:hover {
    box-shadow: none;
  }

  &.ant-switch {
    opacity: 0.5;
    background: #d092dd;
    border-color: #d092dd;
  }

  &.ant-switch-checked {
    opacity: 1;
  }

  .ant-switch-inner {
    font-size: 12px;
    font-weight: 500;
    line-height: 100%;
  }

  .ant-switch-handle::before {
    background: #ffffff;
  }
`
